import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import {
  FaClipboardList,
  FaCog,
  FaExclamationTriangle,
  FaHistory,
  FaMobileAlt,
  FaUser,
  FaUserAlt,
  FaUsers,
} from 'react-icons/fa';
import {
  SidebarButtonLink,
  SidebarDivider,
  SidebarSection,
} from '../../components/layouts/SidebarLayout';
import { useAppContext } from '../../hooks/useAppContext';
import { usePermission } from '../../hooks/usePermission';
import { NotificationCenterButton } from '../notification/NotificationCenterButton';
import { UserMenu } from '../user/UserMenu';

interface Props {
  isShrunk: boolean;
}

export const OrganizationSidebar = (props: Props) => {
  const { isShrunk } = props;
  const { organization } = useAppContext();

  const incidentsPermission = usePermission('read', 'incident');
  const usersPermission = usePermission('create', 'user');
  const settingsPermission = usePermission('update', 'organization');
  const templatesPermission = usePermission('create', 'template');
  const auditTrailPermission = usePermission('read', 'auditTrail');

  return (
    <ChakraV3.Stack h='full' gap={0}>
      <SidebarDivider />

      <SidebarSection>
        <NotificationCenterButton isShrunk={isShrunk} />
        <SidebarButtonLink
          to={`/organizations/${organization.id}/participants`}
          leftIcon={<FaUserAlt />}
          isShrunk={isShrunk}
        >
          Participants
        </SidebarButtonLink>

        <SidebarButtonLink
          to={`/organizations/${organization.id}/incidents`}
          leftIcon={<FaExclamationTriangle />}
          disabled={!incidentsPermission}
          isShrunk={isShrunk}
        >
          Incidents
        </SidebarButtonLink>
        <SidebarButtonLink to={'/recording'} leftIcon={<FaMobileAlt />} isShrunk={isShrunk}>
          Mobile data collection
        </SidebarButtonLink>
      </SidebarSection>

      {(usersPermission || templatesPermission || settingsPermission) && <SidebarDivider />}

      <SidebarSection>
        {usersPermission && (
          <SidebarButtonLink
            to={`/organizations/${organization.id}/users`}
            leftIcon={<FaUsers />}
            isShrunk={isShrunk}
          >
            Users
          </SidebarButtonLink>
        )}
        {templatesPermission && (
          <SidebarButtonLink
            to={`/organizations/${organization.id}/templates`}
            disabled={!templatesPermission}
            leftIcon={<FaClipboardList />}
            isShrunk={isShrunk}
          >
            Templates
          </SidebarButtonLink>
        )}
        {auditTrailPermission && (
          <SidebarButtonLink
            to={`/organizations/${organization.id}/audit-trail`}
            disabled={false}
            leftIcon={<FaHistory />}
            isShrunk={isShrunk}
          >
            Audit Trail
          </SidebarButtonLink>
        )}
        {settingsPermission && (
          <SidebarButtonLink
            to={`/organizations/${organization.id}/settings`}
            disabled={!settingsPermission}
            leftIcon={<FaCog />}
            isShrunk={isShrunk}
          >
            Settings
          </SidebarButtonLink>
        )}
      </SidebarSection>

      <ChakraV3.Spacer />

      <SidebarSection>
        <SidebarButtonLink
          to={`/organizations/${organization.id}/user/profile`}
          leftIcon={<FaUser />}
          color='gray.400'
          isShrunk={isShrunk}
        >
          Profile
        </SidebarButtonLink>
      </SidebarSection>
      <SidebarDivider />
      <SidebarSection>
        <UserMenu isShrunk={isShrunk} />
      </SidebarSection>
    </ChakraV3.Stack>
  );
};
